var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.4,
    height: 33.4,
    viewBox: "0 0 33.4 33.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 33.4,
    height: 33.4,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M16.7,0A16.7,16.7,0,1,0,33.4,16.7,16.719,16.719,0,0,0,16.7,0m3.188,16.853-3.156,2.09-8.758,5.8a.176.176,0,0,1-.264-.153V8.81a.176.176,0,0,1,.264-.153l11.914,7.89a.176.176,0,0,1,0,.305m2.823,7.737a.171.171,0,0,1-.171.171h-1.4a.171.171,0,0,1-.171-.171V8.811a.171.171,0,0,1,.171-.171h1.4a.171.171,0,0,1,.171.171Zm2.979,0a.171.171,0,0,1-.171.171h-1.4a.171.171,0,0,1-.171-.171V8.811a.171.171,0,0,1,.171-.171h1.4a.171.171,0,0,1,.171.171Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.e771b4d5c33b0844f309ea7b3eaebb78.svg";
export { ForwardRef as ReactComponent };